import { useEffect } from 'react'

const pageStyle = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#f2f4f8',
  padding: 16,
}

const cardStyle = {
  width: '100%',
  maxWidth: 420,
  background: 'white',
  borderRadius: 16,
  border: '0.5px solid #e2e8f0',
  boxShadow: '0 8px 30px rgba(15, 23, 42, 0.08)',
  padding: 32,
  textAlign: 'center',
}

// Landing page for the Facebook OAuth popup opened by useOAuthPopup
// (see ChatIntegrations.jsx). The parent window only cares that the
// popup closes; this page confirms success and closes itself.
export default function FacebookConnectedPage() {
  useEffect(() => {
    const timer = setTimeout(() => window.close(), 800)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <div style={{ fontSize: 40 }}>✅</div>
        <h2 style={{ margin: '12px 0 4px', fontSize: 18 }}>Facebook Page connected</h2>
        <p style={{ color: '#666', fontSize: 13 }}>This window will close automatically.</p>
      </div>
    </div>
  )
}
